module.exports = __webpack_public_path__ + "img/bankcards.f63a89a6.png";